import React, { useState, useEffect } from "react";
import classnames from "classnames";

import styles from "./Pager.module.css";

interface Props {
  current: number;
  handler: (current: number) => void;
  pageSize?: number;
  total: number;
  viewSize?: number;
}

function Pager(props: Props) {
  const {
    current = 1,
    handler,
    pageSize = 40,
    total = 0,
    viewSize = 5
  } = props;

  const [begin, setBegin] = useState(0);
  const [end, setEnd] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  useEffect(() => {
    const totalP = Math.ceil(total / pageSize);
    setTotalPage(totalP);
    if (totalP < viewSize + 2) {
      setBegin(2);
      setEnd(totalP);
    } else if (current >= totalP - viewSize) {
      setBegin(totalP - viewSize);
      setEnd(totalP);
    } else {
      setBegin(Math.max(2, current - Math.floor(viewSize / 2)));
      setEnd(
        Math.min(
          totalP,
          Math.max(2, current - Math.floor(viewSize / 2)) + viewSize
        )
      );
    }
  }, [current, viewSize, total, pageSize]);

  return totalPage > 1 ? (
    <div className={styles.container}>
      {current > 1 && (
        <button onClick={() => handler(current - 1)} className={styles.prev}>
          上一页
        </button>
      )}
      <button
        className={classnames({
          [styles.current]: current === 1
        })}
        onClick={() => handler(1)}
      >
        1
      </button>
      {begin > 2 && <span>...</span>}
      {Array.from({ length: totalPage + 1 }, (value, index) => index)
        .slice(begin, end + 1)
        .map(item => (
          <button
            key={item}
            className={classnames({
              [styles.current]: current === item
            })}
            onClick={() => handler(item)}
          >
            {item}
          </button>
        ))}
      {end < totalPage && <span>...</span>}
      {current < totalPage && (
        <button onClick={() => handler(current + 1)} className={styles.next}>
          下一页
        </button>
      )}
    </div>
  ) : null;
}

export default Pager;
